// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { create } from "./operations.js";
export type { VaultCertificatesCreateOptionalParams } from "./options.js";
